import {connect} from 'react-redux';
import TeamOwnedVirtualEntryTracker from './TeamOwnedVirtualEntryTracker.jsx';
import {
  setRemoveVirtualEntryConfirmationVisibility
} from '../shared/actionTypes';

const mapStateToProps = state => ({
  childTeamOwnedVirtualEntries: state.registration.shared.childTeamOwnedVirtualEntries,
  childVirtualEntryEvents: state.registration.shared.childVirtualEntryEvents,
  parentTeamOwnedVirtualEntries: state.registration.shared.parentTeamOwnedVirtualEntries,
  parentVirtualEntryEvents: state.registration.shared.parentVirtualEntryEvents
});

const mapDispatchToProps = dispatch => ({
  onRemoveUnassignedVirtualEntries: (value, virtualEventName, childOrParent, quantity) => 
    dispatch(setRemoveVirtualEntryConfirmationVisibility(value, virtualEventName, childOrParent, quantity))
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamOwnedVirtualEntryTracker);


// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/TeamOwnedVirtualEntryTrackerContainer.jsx